import { setAutoFreeze } from 'immer';

setAutoFreeze(false);

export { default as removeReplayLayer } from './removeReplayLayer';
export { default as unGroupReplayLayers } from './unGroupReplayLayers';
export { default as getIdentityShapeLocation } from './getIdentityShapeLocation';
